export const pattern24Data = [
  {
    koreanChunks: ["제출해 주세요 최종보고서를", "검토가 완료된 후"],
    englishChunks: [
      "Please submit the final report",
      "after the review is complete",
    ],
    fullEnglish: "Please submit the final report after the review is complete.",
    additionalExplanation:
      "전치사는 뒤에 명사(구)만 옵니다. 접속사는 주어+동사 형태로 전치사가 말을 할 때 하나씩 내용을 추가하는 느낌이었다면 접속사는 문장을 이을 때 사용합니다. 원어민이 문장을 말하고 다음 문장을 말할 때 그 문장 사이에 연관성을 나타내고자 할 때 사용합니다.",
  },
  {
    koreanChunks: [
      "이익이 감소했음에도 불구하고 약간",
      "전반적인 성과는 유지했습니다 강세를",
    ],
    englishChunks: [
      "Although profits declined slightly",
      "overall performance remained strong",
    ],
    fullEnglish:
      "Although profits declined slightly, overall performance remained strong.",
    additionalExplanation:
      "'~ 했음에도 불구하고'라고 말할 때는 접속사를 먼저 말하고 그 뒤에 내용을 붙입니다. 우리가 해석할 때는 접속사는 건너뛰고 연결된 주어 + 동사를 먼저 읽고 접속사를 뒤에 붙여 (이익이 감소했음에도 불구하고) 읽습니다.",
  },
  {
    koreanChunks: [
      "직원들은 반드시 서명해야 합니다  출석부에",
      "그리고 제출해야 합니다 그들의 신분증을",
    ],
    englishChunks: [
      "Employees must sign the attendance sheet",
      "and submit their ID cards",
    ],
    fullEnglish:
      "Employees must sign the attendance sheet and submit their ID cards.",
    additionalExplanation:
      "must 뒤에 나오는 sign과 submit을 and로 연결해서 문장을 이었습니다. 영어 어순대로 읽으면 문제없이 해석될 수 있습니다.",
  },
  {
    koreanChunks: [
      "우리가 알고 있는 한",
      "배송이 지연되었습니다",
      "세관 때문에",
    ],
    englishChunks: [
      "As far as we know",
      "the shipment has been delayed",
      "due to customs",
    ],
    fullEnglish:
      "As far as we know, the shipment has been delayed due to customs.",
    additionalExplanation:
      "'우리가 알고 있는 한'이라는 말을 하고 싶다면 영어에서는 우선 'as far as'라는 접속사부터 말하고, 그다음에 문장을 연결합니다. 그러나 읽을 때에는 접속사는 그냥 읽고 지나간 뒤 접속사 뒤 주어+동사를 읽고 접속사의 의미를 붙여 (우리가 알고 있는 한) 두 문장 사이 관계를 확인합니다.",
  },
  {
    koreanChunks: [
      "우리의 새 매트리스는 느껴집니다",
      "마치 당신이 자는 것처럼",
      "공기 위에서",
    ],
    englishChunks: [
      "Our new mattress feels",
      "as if you're sleeping ",
      "on air",
    ],
    fullEnglish: "Our new mattress feels as if you're sleeping on air.",
    additionalExplanation:
      "'as if'는 '마치 ~인 것처럼'이라는 의미의 접속사로, 가상의 상황이나 비유를 표현할 때 사용됩니다. 마찬가지로 ~인 것처럼 이라는 말을 하고 싶으면 접속사를 먼저 말하지만 해석 시에는 건너뛰고 주어 + 동사 + 그리고 접속사를 연결지어 읽습니다.",
  },
  {
    koreanChunks: [
      "당신은 일할 수 있습니다 원격으로",
      "당신이 제출하는 한",
      "당신의 업무를",
      "제시간에",
    ],
    englishChunks: [
      "You may work remotely",
      "as long as you submit",
      "your tasks",
      "on time",
    ],
    fullEnglish:
      "You may work remotely as long as you submit your tasks on time.",
    additionalExplanation:
      "'as long as'는 '~하는 한', '~라면'이라는 의미의 접속사로, 조건을 나타낼 때 사용됩니다. 말할 때는 접속사를 먼저 말하고 어떤 경우의 한에서인지 설명하고, 읽을 때는 접속사를 건너뛰고 뒤에 주어 + 동사 + 접속사 이렇게 해석합니다",
  },
  {
    koreanChunks: ["제가 알려드릴게요 당신에게", "서류가 승인되는 즉시"],
    englishChunks: ["I'll notify you", "as soon as the documents are approved"],
    fullEnglish: "I'll notify you as soon as the documents are approved.",
    additionalExplanation:
      "'as soon as'는 '~하자마자', '~하는 즉시'라는 의미의 접속사로, 어떤 일이 발생하자마자 다른 일이 일어날 것임을 나타낼 때 사용합니다. 말할 때는 접속사를 먼저 말하고, 읽을 때는 접속사를 건너뛰고 주어 + 동사를 읽은 후 접속사의 의미를 연결하여 해석합니다.",
  },
  {
    koreanChunks: [
      "매니저는 응답했습니다",
      "마치 그가 예상한 것처럼",
      "결과를",
    ],
    englishChunks: [
      "The manager responded",
      "as though he had expected",
      "the outcome",
    ],
    fullEnglish: "The manager responded as though he had expected the outcome.",
    additionalExplanation:
      "'as though'는 'as if'와 같은 의미로 '마치 ~인 것처럼'이라는 뜻의 접속사입니다. 영어로 말할 때는 접속사를 먼저 말하지만, 해석할 때는 접속사를 건너뛰고 주어 + 동사를 읽은 후 접속사의 의미를 연결하여 해석합니다.",
  },
  {
    koreanChunks: ["발사가 연기되었습니다", "기술적 문제가 발견되었기 때문에"],
    englishChunks: [
      "The launch has been postponed",
      "because technical issues were discovered",
    ],
    fullEnglish:
      "The launch has been postponed because technical issues were discovered.",
    additionalExplanation:
      "'because'는 '~때문에', '~이유로'라는 의미의 접속사로, 원인이나 이유를 설명할 때 사용됩니다. 영어로 말할 때는 접속사를 먼저 말하고 이유를 설명하지만, 해석할 때는 주어 + 동사를 먼저 읽고 접속사의 의미를 연결하여 해석합니다. ",
  },
  {
    koreanChunks: [
      "저희는 이해합니다 당신의 우려를,",
      "하지만 마감일은 변경되지 않은 상태로 남아있습니다",
    ],
    englishChunks: [
      "We understand your concerns,",
      "but the deadline remains unchanged",
    ],
    fullEnglish:
      "We understand your concerns, but the deadline remains unchanged.",
    additionalExplanation:
      "'but'은 '하지만', '그러나'라는 의미의 접속사로, 앞서 언급된 내용과 대조되는 내용을 이어줄 때 사용됩니다. 현재 이 문장의 경우 콤마와 같이 연결된 경우로 이 경우는 영어 어순대로 그대로 읽고 해석도 똑같이 하면 됩니다. ",
  },
  {
    koreanChunks: ["초기 판매량은 인상적입니다", "제품이 새로운 것을 고려하면"],
    englishChunks: [
      "Early sales are impressive,",
      "considering that the product is new",
    ],
    fullEnglish:
      "Early sales are impressive, considering that the product is new.",
    additionalExplanation:
      "'considering that'은 '~을 고려하면', '~을 감안할 때'라는 의미의 접속사로, 어떤 상황이나 사실을 고려했을 때의 결론이나 의견을 나타낼 때 사용합니다. 영어로 말할 때는 접속사를 먼저 말하고 고려할 상황을 설명하지만, 해석할 때는 주어 + 동사를 먼저 읽고 접속사의 의미를 연결하여 해석합니다.",
  },
  {
    koreanChunks: [" 완료해 주세요 설문조사를", "교육 세션이 시작되기 전까지"],
    englishChunks: [
      "Please complete the survey",
      "by the time the training session begins",
    ],
    fullEnglish:
      "Please complete the survey by the time the training session begins.",
    additionalExplanation:
      "'by the time'은 '~까지', '~하기 전에'라는 의미의 접속사로, 특정 시간이나 사건이 발생하기 전에 무언가가 완료될 것임을 나타냅니다. 영어로 말할 때는 접속사를 먼저 말하고 시간적 기준점을 설명하지만, 해석할 때는 주어 + 동사를 먼저 읽고 접속사의 의미를 연결하여 해석합니다.",
  },
  {
    koreanChunks: [
      "수요가 둔화되었음에도 불구하고",
      "이익은 유지되고 있습니다 안정적으로",
    ],
    englishChunks: [
      "Despite the fact that demand has slowed,",
      "profits remain steady",
    ],
    fullEnglish:
      "Despite the fact that demand has slowed, profits remain steady.",
    additionalExplanation:
      "'Despite the fact that'는 '~에도 불구하고'라는 의미의 접속사로, 어떤 상황이나 사실이 예상과 다른 결과를 가져올 때 사용합니다. 영어로 말할 때는 접속사를 먼저 말하고 상황을 설명하지만, 해석할 때는 접속사의 의미를 먼저 읽고 주어 + 동사를 연결하여 해석합니다.",
  },
  {
    koreanChunks: ["당신이 늦더라도", "당신은 참석해야 합니다 전체 세션에"],
    englishChunks: ["Even if you're late,", "you must attend the full session"],
    fullEnglish: "Even if you're late, you must attend the full session.",
    additionalExplanation:
      "'Even if'는 '~하더라도', '~일지라도'라는 의미의 접속사로, 어떤 조건이나 상황에도 불구하고 결과가 변하지 않음을 나타낼 때 사용합니다. 영어로 말할 때는 접속사를 먼저 말하고 조건을 설명하지만, 해석할 때는 접속사의 의미를 먼저 읽고 주어 + 동사를 연결하여 해석합니다.",
  },
  {
    koreanChunks: [
      "우리가 증가시켰음에도 불구하고",
      "마케팅 노력들을",
      "판매량은 변동이 없었습니다",
    ],
    englishChunks: [
      "Even though we increased",
      "marketing efforts,",
      "sales remained flat",
    ],
    fullEnglish:
      "Even though we increased marketing efforts, sales remained flat.",
    additionalExplanation:
      "'Even though'는 '~에도 불구하고'라는 의미의 접속사로, 예상과 다른 결과가 발생했을 때 사용합니다. 영어로 말할 때는 접속사를 먼저 말하고 조건이나 상황을 설명하지만, 해석할 때는 접속사의 의미를 먼저 읽고 주어 + 동사를 연결하여 해석합니다.",
  },
  {
    koreanChunks: [
      "비용이 상승하고 있다는 점을 고려할 때",
      "가격 조정은 정당화됩니다",
    ],
    englishChunks: [
      "Given that costs are rising,",
      "the price adjustment is justified",
    ],
    fullEnglish:
      "Given that costs are rising, the price adjustment is justified.",
    additionalExplanation:
      "'Given that'은 '~을 고려하면', '~을 감안할 때'라는 의미의 접속사로, 어떤 상황이나 사실을 전제로 결론을 도출할 때 사용합니다. 영어로 말할 때는 접속사를 먼저 말하고 전제 조건을 설명하지만, 해석할 때는 접속사의 의미를 먼저 읽고 주어 + 동사를 연결하여 해석합니다.",
  },
  {
    koreanChunks: [
      "우리에게 알려주세요",
      "만약 당신이 가지고 있다면",
      "어떤 질문들을",
      "첨부된 인보이스에 대해",
    ],
    englishChunks: [
      "Let us know",
      "if you have",
      "any questions",
      "about the attached invoice",
    ],
    fullEnglish:
      "Let us know if you have any questions about the attached invoice.",
    additionalExplanation:
      "'If'는 '만약 ~라면', '~한다면'이라는 의미의 접속사로, 조건을 나타낼 때 사용합니다.",
  },
  {
    koreanChunks: [
      "유지하세요 당신의 배지를 보이도록",
      "보안이 요구할 경우를 대비해서",
      "신분증을",
    ],
    englishChunks: [
      "Keep your badge visible",
      "in case security requests",
      "identification",
    ],
    fullEnglish:
      "Keep your badge visible in case (that) security requests identification.",
    additionalExplanation:
      "'In case (that)'는 '~할 경우를 대비하여', '~할 가능성에 대비하여'라는 의미의 접속사로, 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석",
  },
  {
    koreanChunks: [
      "우리는 단순화했습니다 인터페이스를 ",
      "사용자들이 탐색할 수 있도록",
      "더 쉽게",
    ],
    englishChunks: [
      "We simplified the interface",
      "in order that users can navigate",
      "more easily",
    ],
    fullEnglish:
      "We simplified the interface in order that users can navigate more easily.",
    additionalExplanation:
      "'In order that'는 '~하기 위해서', '~할 수 있도록'이라는 의미의 접속사로, 목적이나 의도를 나타낼 때 사용합니다. 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: ["시스템이 실패할 경우에", "즉시 IT에 연락하세요"],
    englishChunks: [
      "In the event that the system fails,",
      "contact IT immediately",
    ],
    fullEnglish: "In the event that the system fails, contact IT immediately.",
    additionalExplanation:
      "'In the event that'는 '~할 경우에', '~하는 상황이 발생하면'이라는 의미의 접속사로, 특정 상황이 발생했을 때 취해야 할 행동을 설명할 때 사용합니다. 이 표현은 공식적인 문서나 비즈니스 상황에서 자주 사용되며, 'if'보다 더 격식 있는 표현입니다. 'that'은 생략 가능하며, 'in case'나 'if'로 대체할 수도 있습니다.",
  },
  {
    koreanChunks: ["우리가 예상했던 대로", "고객이 승인했습니다 제안을"],
    englishChunks: ["Just as we expected,", "the client approved the proposal"],
    fullEnglish: "Just as we expected, the client approved the proposal.",
    additionalExplanation:
      "'Just as'는 '~와 같이', '~대로'라는 의미의 접속사로, 예상이나 기대와 일치하는 상황을 설명할 때 사용합니다. 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: [
      "이 소프트웨어는 빠를 뿐만 아니라",
      "사용자 친화적이기도 합니다",
    ],
    englishChunks: [
      "Not only is this software fast,",
      "but it's also user-friendly",
    ],
    fullEnglish: "Not only is this software fast, but it's also user-friendly.",
    additionalExplanation:
      "'Not only... but also...'는 '~뿐만 아니라 ~도'라는 의미의 상관접속사로, 두 가지 이상의 특성이나 상황을 강조할 때 사용합니다. 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: ["합병이 완료된 지금", "운영이 통합될 것입니다"],
    englishChunks: [
      "Now that the merger is complete,",
      "operations will be consolidated",
    ],
    fullEnglish:
      "Now that the merger is complete, operations will be consolidated.",
    additionalExplanation:
      "'Now that'는 '~이제', '~한 이상', '~하게 되었으므로'라는 의미의 접속사로, 어떤 상황이 발생했거나 조건이 충족되어 그 결과로 무언가가 일어남을 나타냅니다. 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다..",
  },
  {
    koreanChunks: [
      "당신이 완료하면",
      "온보딩을,",
      "당신을 받게 될것입니다 시스템 접근 권한을",
    ],
    englishChunks: [
      "Once you complete",
      "onboarding,",
      "you'll receive system access",
    ],
    fullEnglish: "Once you complete onboarding, you'll receive system access.",
    additionalExplanation:
      "'Once'는 '~하면', '~하자마자'라는 의미의 접속사로, 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: [
      "당신은 입장할 수 있습니다 실험실에",
      "당신이 착용한 경우에만",
      "안전장비를",
    ],
    englishChunks: [
      "You may enter the lab",
      "only if you are wearing",
      "safety gear",
    ],
    fullEnglish: "You may enter the lab only if you are wearing safety gear.",
    additionalExplanation:
      "'Only if'는 '~하는 경우에만'이라는 의미의 접속사로, 특정 조건이 충족되어야만 어떤 일이 가능함을 강조할 때 사용합니다.마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: [
      "알려주세요",
      "당신이 선호하는지",
      "전화 통화 또는 화상회의 중에서",
    ],
    englishChunks: [
      "Let me know",
      "if you'd prefer",
      "a phone call or a video meeting",
    ],
    fullEnglish: "Let me know if you'd prefer a phone call or a video meeting.",
    additionalExplanation:
      "'If'는 '만약 ~라면', '~인지 아닌지'라는 의미의 접속사로, 조건이나 가능성을 나타낼 때 사용합니다. 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: [
      "휴가 요청은 승인될 것입니다",
      "충족한다는 조건 하에",
      "정책 요구사항을",
    ],
    englishChunks: [
      "Leave requests will be approved",
      "provided that they meet",
      "policy requirements",
    ],
    fullEnglish:
      "Leave requests will be approved provided that they meet policy requirements.",
    additionalExplanation:
      "'Provided that'는 '~한다는 조건 하에', '~하는 한'이라는 의미의 접속사로, 특정 조건이 충족되면 어떤 일이 발생할 것임을 나타냅니다. 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: [
      "우리는 선택했습니다",
      "업그레이드하기로 소프트웨어를",
      "교체하기보다는 그것을",
    ],
    englishChunks: [
      "We chose",
      "to upgrade the software",
      "rather than replace it",
    ],
    fullEnglish: "We chose to upgrade the software rather than replace it.",
    additionalExplanation:
      "'Rather than'은 '~하기보다는'이라는 의미의 접속사로, 두 가지 선택지 중에서 선호되는 것과 그렇지 않은 것을 대조할 때 사용합니다. 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },

  {
    koreanChunks: [
      "서버가 다운되었습니다, ",
      "그래서 지연해야 할 것입니다 업로드를",
    ],
    englishChunks: ["The server is down,", "so we'll need to delay the upload"],
    fullEnglish: "The server is down, so we'll need to delay the upload.",
    additionalExplanation:
      "'So'는 '그래서', '따라서'라는 의미의 접속사로, 원인과 결과의 관계를 나타낼 때 사용합니다.콤마로 연결된 구조로 읽는 순서 말하는 순서 모두 같습니다.",
  },
  {
    koreanChunks: [
      "라벨하세요 당신의 물품에  명확하게",
      "그들이 잘못 배치되지 않도록",
    ],
    englishChunks: [
      "Please label your items clearly",
      "so that they are not misplaced",
    ],
    fullEnglish:
      "Please label your items clearly so that they are not misplaced.",
    additionalExplanation:
      "'So that'은 '~하기 위해서', '~하도록'이라는 의미의 접속사로, 목적이나 의도를 나타낼 때 사용합니다. 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: [
      "고객이 동의한다고 가정하면,",
      "우리가 진행할 수 있을까요",
      "다음 주까지?",
    ],
    englishChunks: [
      "Supposing that the client agrees,",
      "can we proceed",
      "by next week?",
    ],
    fullEnglish:
      "Supposing that the client agrees, can we proceed by next week?",
    additionalExplanation:
      "'Supposing that'은 '~라고 가정하면', '~한다면'이라는 의미의 접속사로, 가상의 상황이나 가정을 제시할 때 사용합니다. 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: ["결과는 긍정적이었습니다", "예상 밖은 아니었지만"],
    englishChunks: ["The results were positive,", "though not unexpected"],
    fullEnglish: "The results were positive, though not unexpected.",
    additionalExplanation:
      "'Though'는 '비록 ~일지라도', '~에도 불구하고'라는 의미의 접속사로, 양보나 대조를 나타낼 때 사용합니다. 이는 'Although'나 'Even though'와 유사하며, 두 가지 상반된 사실이나 생각 사이의 대조를 표현할 때 효과적입니다.",
  },
  {
    koreanChunks: [
      "당신은 자격이 안될 겁니다",
      "혜택을 위한",
      "당신이 등록하지 않는 한",
      "금요일까지",
    ],
    englishChunks: [
      "You will not be eligible",
      "for benefits",
      "unless you enroll",
      "by Friday",
    ],
    fullEnglish:
      "You will not be eligible for benefits unless you enroll by Friday.",
    additionalExplanation:
      "'Unless'는 '~하지 않는 한', '~이 아니면'이라는 의미의 접속사로, 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: [
      "우리는 보류할 것입니다 당신의 주문을",
      "결제가 확인될 때까지",
    ],
    englishChunks: ["We will hold your order", "until payment is confirmed"],
    fullEnglish: "We will hold your order until payment is confirmed.",
    additionalExplanation:
      "'Until'은 '~까지', '~할 때까지'라는 의미의 접속사로, 어떤 행동이나 상태가 특정 시점이나 사건까지 계속됨을 나타냅니다. 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: ["고객은 받을것입니다 알림들을", "그들의 물품이 배송될 때"],
    englishChunks: [
      "Customers will receive notifications",
      "when their items ship",
    ],
    fullEnglish: "Customers will receive notifications when their items ship.",
    additionalExplanation:
      "'When'은 '~할 때', '~하는 시점에'라는 의미의 접속사로, 특정 시간이나 상황에서 발생하는 행동이나 사건을 나타냅니다. 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: [
      "마케팅 지출이 증가했습니다,",
      "반면에 R&D 자금은 안정적으로 유지되었습니다",
    ],
    englishChunks: [
      "Marketing spending increased,",
      "whereas R&D funding remained steady",
    ],
    fullEnglish:
      "Marketing spending increased, whereas R&D funding remained steady.",
    additionalExplanation:
      "'Whereas'는 '반면에', '~인 반면에'라는 의미의 접속사로, 두 가지 상황이나 사실 사이의 대조나 차이점을 강조할 때 사용합니다. 콤마로 연결되있으니 영어 어순대로 말하고 해석합니다.",
  },
  {
    koreanChunks: [
      "유럽의 판매량은 감소한 반면",
      "아시아-태평양 지역은 보였습니다 성장을",
    ],
    englishChunks: [
      "While sales in Europe declined,",
      "Asia-Pacific showed growth",
    ],
    fullEnglish: "While sales in Europe declined, Asia-Pacific showed growth.",
    additionalExplanation:
      "'While'은 '~하는 동안', '~인 반면에'라는 의미의 접속사로, 시간적 동시성이나 대조를 나타낼 때 사용합니다.마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: [
      "확인해 주시기 바랍니다",
      "당신이 참석할 수 있는지 여부를",
      "세션에",
    ],
    englishChunks: ["Please confirm", "whether you can attend", "the session"],
    fullEnglish: "Please confirm whether you can attend the session.",
    additionalExplanation:
      "'Whether'는 '~인지 아닌지', '~할지 말지'라는 의미의 접속사로, 두 가지 가능성이나 선택 사항을 나타낼 때 사용합니다. 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },

  {
    koreanChunks: [
      "회사가 확장함에 따라",
      "세계적으로",
      "우리는 (현재) 재구성 중입니다 우리의 운영을",
    ],
    englishChunks: [
      "As the company expands",
      "globally,",
      "we are restructuring our operations",
    ],
    fullEnglish:
      "As the company expands globally, we are restructuring our operations.",
    additionalExplanation:
      "'As'는 '~함에 따라', '~할 때', '~이기 때문에'라는 의미의 접속사로, 시간적 동시성이나 인과 관계를 나타낼 때 사용합니다. 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: [
      "위원회는 연기했습니다 투표를,",
      "왜냐하면 여러 회원들이 부재했기 때문에",
    ],
    englishChunks: [
      "The committee postponed the vote,",
      "for several members were absent",
    ],
    fullEnglish:
      "The committee postponed the vote, for several members were absent.",
    additionalExplanation:
      "'For'는 '왜냐하면', '~이기 때문에'라는 의미의 접속사로, 이유나 원인을 설명할 때 사용합니다. 콤마로 연결되어 있어 해석, 말할때 어순이 같습니다.",
  },
  {
    koreanChunks: [
      "예산이 (현재)승인되었기 때문에,",
      "우리는 시작할 수 있습니다 프로젝트를 다음 주에",
    ],
    englishChunks: [
      "Since the budget has been approved,",
      "we can begin the project next week",
    ],
    fullEnglish:
      "Since the budget has been approved, we can begin the project next week.",
    additionalExplanation:
      "'Since'는 '~이후로', '~때문에'라는 의미의 접속사로, 시간적 시작점이나 이유를 나타낼 때 사용합니다. 이 문장에서는 예산 승인이 프로젝트 시작의 이유임을 나타냅니다. 마찬가지로 말할 때는 접속사를 먼저 말하고, 해석 시에는 주어 -> 동사 -> 접속사 순으로 해석합니다.",
  },
  {
    koreanChunks: [
      "모든 직원들은 반드시 로그아웃해야 합니다 시스템에서",
      "그들이 떠나기 전에",
      "사무실을",
    ],
    englishChunks: [
      "All employees must log out of the system",
      "before they leave",
      "the office",
    ],
    fullEnglish:
      "All employees must log out of the system before they leave the office.",
    additionalExplanation:
      "before, after, since, until/till 의 경우 전치사로도 쓰이니 혼돈하지 않습니다",
  },
  {
    koreanChunks: ["직원은 (현재) 휴가 중입니다", "그가 아픈 이후로"],
    englishChunks: ["The employee has been on leave", "since he got sick"],
    fullEnglish: "The employee has been on leave since he got sick.",
    additionalExplanation:
      "before, after, since, until/till 의 경우 전치사로도 쓰이니 혼돈하지 않습니다",
  },
  {
    koreanChunks: ["사무실은 열려있습니다", "마지막 고객이 떠날 때까지"],
    englishChunks: ["The office remains open", "until the last client leaves"],
    fullEnglish: "The office remains open until the last client leaves.",
    additionalExplanation:
      "before, after, since, until/till 의 경우 전치사로도 쓰이니 혼돈하지 않습니다",
  },

  {
    koreanChunks: [
      "배송이 지연되었습니다;",
      "그러나, 우리는 알렸습니다 고객에게 즉시",
    ],
    englishChunks: [
      "The shipment was delayed;",
      "however, we informed the client immediately",
    ],
    fullEnglish:
      "The shipment was delayed; however, we informed the client immediately.",
    additionalExplanation:
      "'However'는 '그러나', '하지만'이라는 의미의 접속부사로, 앞 문장과 대조되는 내용을 이어줍니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'however' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다. ",
  },
  {
    koreanChunks: [
      "시스템 업그레이드가 완료되었습니다;",
      "따라서, 모든 사용자들은 반드시 재설정해야 합니다 그들의 비밀번호를",
    ],
    englishChunks: [
      "The system upgrade is complete;",
      "therefore, all users must reset their passwords",
    ],
    fullEnglish:
      "The system upgrade is complete; therefore, all users must reset their passwords.",
    additionalExplanation:
      "'Therefore'는 '따라서', '그러므로'라는 의미의 접속부사로, 앞 문장의 결과나 논리적 귀결을 나타냅니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'therefore' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "새로운 복리후생 패키지는 포함합니다 추가 휴가일을;",
      "게다가, 치과 보험이 이제 제공됩니다",
    ],
    englishChunks: [
      "The new benefits package includes extra leave days;",
      "moreover, dental coverage is now offered",
    ],
    fullEnglish:
      "The new benefits package includes extra leave days; moreover, dental coverage is now offered.",
    additionalExplanation:
      "'Moreover'는 '게다가', '더욱이'라는 의미의 접속부사로, 앞 문장에 추가적인 정보나 강조점을 더할 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'moreover' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "지원자는 (현재) 가집니다 5년을 경력;",
      "게다가, 그녀는 말합니다 세 개의 언어를.",
    ],
    englishChunks: [
      "The applicant has five years of experience;",
      "furthermore, she speaks three languages",
    ],
    fullEnglish:
      "The applicant has five years of experience; furthermore, she speaks three languages.",
    additionalExplanation:
      "'Furthermore'는 '게다가', '더욱이'라는 의미의 접속부사로, 앞 문장에 추가적인 정보나 강조점을 더할 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'furthermore' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "그 문제는 사소했습니다;",
      "그럼에도 불구하고, 그것은 해결되었습니다 죽사",
    ],
    englishChunks: [
      "The issue was minor;",
      "nevertheless, it was resolved immediately",
    ],
    fullEnglish:
      "The issue was minor; nevertheless, it was resolved immediately.",
    additionalExplanation:
      "'Nevertheless'는 '그럼에도 불구하고', '그래도'라는 의미의 접속부사로, 앞 문장의 내용에도 불구하고 뒤 문장의 내용이 진행됨을 나타냅니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'nevertheless' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "팀은 마감일을 실패했습니다",
      "맞추는 것을 마감일을;",
      "따라서, 프로젝트가 재배정되었습니다",
    ],
    englishChunks: [
      "The team failed",
      "to meet the deadline;",
      "thus, the project was reassigned",
    ],
    fullEnglish:
      "The team failed to meet the deadline; thus, the project was reassigned.",
    additionalExplanation:
      "'Thus'는 '따라서', '그러므로'라는 의미의 접속부사로, 앞 문장의 결과나 논리적 귀결을 나타냅니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'thus' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "서버가 불안정했습니다;",
      "그래서, 우리는 예약했습니다 긴급 유지보수를 ",
    ],
    englishChunks: [
      "The server was unstable;",
      "hence, we scheduled emergency maintenance",
    ],
    fullEnglish:
      "The server was unstable; hence, we scheduled emergency maintenance.",
    additionalExplanation:
      "'Hence'는 '그래서', '따라서'라는 의미의 접속부사로, 앞 문장의 결과나 논리적 귀결을 나타냅니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'hence' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "도착해 주세요",
      "제시간에;",
      "그렇지 않으면, 당신의 예약은 취소될 것입니다",
    ],
    englishChunks: [
      "Please arrive",
      "on time;",
      "otherwise, your appointment will be canceled",
    ],
    fullEnglish:
      "Please arrive on time; otherwise, your appointment will be canceled.",
    additionalExplanation:
      "'Otherwise'는 '그렇지 않으면', '그러지 않으면'이라는 의미의 접속부사로, 앞 문장의 조건이 충족되지 않을 경우 발생할 결과를 나타냅니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'otherwise' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "회사는 확장했습니다 회사의 서비스를;",
      "결과적으로, 고객 만족도가 향상되었습니다",
    ],
    englishChunks: [
      "The company expanded its services;",
      "consequently, customer satisfaction improved",
    ],
    fullEnglish:
      "The company expanded its services; consequently, customer satisfaction improved.",
    additionalExplanation:
      "'Consequently'는 '결과적으로', '따라서'라는 의미의 접속부사로, 앞 문장의 직접적인 결과를 나타냅니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'consequently' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "우리는 받았습니다 당신의 피드백을;",
      "그에 따라, 변경사항이 (현재) 만들어졌습니다",
      "시스템에",
    ],
    englishChunks: [
      "We received your feedback;",
      "accordingly, changes have been made",
      "to the system",
    ],
    fullEnglish:
      "We received your feedback; accordingly, changes have been made to the system.",
    additionalExplanation:
      "'Accordingly'는 '그에 따라', '그러므로'라는 의미의 접속부사로, 앞 문장에 맞춰 취해진 조치나 반응을 나타냅니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'accordingly' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "파일들이 (현재)업로드되는 중입니다;",
      "그 동안, 끝내주세요 체크리스트를",
    ],
    englishChunks: [
      "The files are being uploaded;",
      "meanwhile, please complete the checklist",
    ],
    fullEnglish:
      "The files are being uploaded; meanwhile, please complete the checklist.",
    additionalExplanation:
      "'Meanwhile'는 '그 동안', '그러는 동안'이라는 의미의 접속부사로, 앞 문장의 행동이 진행되는 동안 다른 행동이 일어남을 나타냅니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'meanwhile' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "제안서가 거부되었습니다;",
      "대신, 수정된 버전이 제출되었습니다",
    ],
    englishChunks: [
      "The proposal was rejected;",
      "instead, a revised version was submitted",
    ],
    fullEnglish:
      "The proposal was rejected; instead, a revised version was submitted.",
    additionalExplanation:
      "'Instead'는 '대신에', '그 대신'이라는 의미의 접속부사로, 앞 문장 대신 다른 대안이나 행동이 취해졌음을 나타냅니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'instead' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "모바일 버전이 이제 이용 가능합니다;",
      "게다가, 새로운 보안 기능들이 추가되었습니다",
    ],
    englishChunks: [
      "A mobile version is now available;",
      "in addition, new security features were added",
    ],
    fullEnglish:
      "A mobile version is now available; in addition, new security features were added.",
    additionalExplanation:
      "'In addition'은 '게다가', '또한'이라는 의미의 접속부사로, 앞 문장에 추가적인 정보를 더할 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'in addition' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "서류가 불완전합니다;",
      "그래도, 우리는 받았습니다 신청서를",
    ],
    englishChunks: [
      "The documents are incomplete;",
      "still, we accepted the application",
    ],
    fullEnglish:
      "The documents are incomplete; still, we accepted the application.",
    additionalExplanation:
      "'Still'은 '그래도', '여전히'라는 의미의 접속부사로, 앞 문장의 내용에도 불구하고 뒤 문장의 내용이 진행됨을 나타냅니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'still' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "그는 제출했습니다 그의 보고서를",
      "제시간에;",
      "마찬가지로, 모든 팀원들도 기대됩니다",
      "할것으로 똑같이",
    ],
    englishChunks: [
      "He submitted his report",
      "on time;",
      "likewise, all team members are expected",
      "to do the same",
    ],
    fullEnglish:
      "He submitted his report on time; likewise, all team members are expected to do the same.",
    additionalExplanation:
      "'Likewise'는 '마찬가지로', '유사하게'라는 의미의 접속부사로, 앞 문장과 유사한 상황이나 행동이 뒤 문장에서도 적용됨을 나타냅니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'likewise' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "계약은 포함합니다 소프트웨어 업데이트를;",
      "그것은 또한 포함합니다 기술 지원도",
    ],
    englishChunks: [
      "The contract covers software updates;",
      "it also includes technical support",
    ],
    fullEnglish:
      "The contract covers software updates; it also includes technical support.",
    additionalExplanation:
      "'Also'는 '또한', '역시'라는 의미의 접속부사로, 앞 문장에 추가적인 정보를 더할 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'also'는 일반적으로 주어와 동사 사이에 위치합니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "완료하세요 설문조사를;",
      "그런 다음, 제출하세요 설문조사를",
      "HR 부서에",
    ],
    englishChunks: [
      "Finish the survey;",
      "then, submit it",
      "to the HR department",
    ],
    fullEnglish: "Finish the survey; then, submit it to the HR department.",
    additionalExplanation:
      "'Then'은 '그런 다음', '그 후에'라는 의미의 접속부사로, 시간적 순서나 단계를 나타낼 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'then' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "우리는 논의할 것입니다 마케팅 계획을;",
      "다음으로, 우리는 다룰 것입니다 물류를",
    ],
    englishChunks: [
      "We'll discuss marketing plans;",
      "next, we'll cover logistics",
    ],
    fullEnglish: "We'll discuss marketing plans; next, we'll cover logistics.",
    additionalExplanation:
      "'Next'는 '다음으로', '그 다음에'라는 의미의 접속부사로, 순서나 단계를 나타낼 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'next' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "판매가 증가했습니다",
      "유럽에서;",
      "유사하게, 수치가 상승했습니다",
      "아시아에서",
    ],
    englishChunks: [
      "Sales increase",
      "in Europe;",
      "similarly, numbers rose",
      "in Asia",
    ],
    fullEnglish: "Sales increased in Europe; similarly, numbers rose in Asia.",
    additionalExplanation:
      "'Similarly'는 '유사하게', '비슷하게'라는 의미의 접속부사로, 앞 문장과 유사한 상황이나 결과가 뒤 문장에서도 나타남을 표현합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'similarly' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "팀이 놓쳤습니다 마감일을;",
      "그 후, 프로젝트가 재배정되었습니다",
    ],
    englishChunks: [
      "The team missed the deadline;",
      "subsequently, the project was reassigned",
    ],
    fullEnglish:
      "The team missed the deadline; subsequently, the project was reassigned.",
    additionalExplanation:
      "'Subsequently'는 '그 후에', '이어서'라는 의미의 접속부사로, 시간적 순서나 결과를 나타낼 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'subsequently' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "첫 번째 지점은 보고했습니다 성장을;",
      "대조적으로, 두 번째 지점은 보았습니다 하락을",
    ],
    englishChunks: [
      "The first branch reported growth;",
      "in contrast, the second saw a decline",
    ],
    fullEnglish:
      "The first branch reported growth; in contrast, the second saw a decline.",
    additionalExplanation:
      "'In contrast'는 '대조적으로', '반면에'라는 의미의 접속구로, 앞 문장과 대조되는 내용을 소개할 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'in contrast' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "수요가 증가했습니다 급격히;",
      "그 결과, 재고가 소진되었습니다",
    ],
    englishChunks: [
      "Demand increased rapidly;",
      "as a result, inventory ran out",
    ],
    fullEnglish: "Demand increased rapidly; as a result, inventory ran out.",
    additionalExplanation:
      "'As a result'는 '그 결과', '따라서'라는 의미의 접속구로, 원인과 결과의 관계를 나타낼 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'as a result' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "회사는 초과했습니다 회사의 목표를;",
      "사실, 회사는 두배를 달성했습니다 회사의 목표를. ",
    ],
    englishChunks: [
      "The company exceeded its goal;",
      "in fact, it doubled its target",
    ],
    fullEnglish:
      "The company exceeded its goal; in fact, it doubled its target.",
    additionalExplanation:
      "'In fact'는 '사실', '실제로'라는 의미의 접속구로, 앞서 언급한 내용을 강조하거나 더 정확한 정보를 제공할 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'in fact' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "소프트웨어는 신뢰할 수 있습니다;",
      "실제로, 소프트웨어는 (현재) 충돌한 적이 없습니다",
    ],
    englishChunks: [
      "The software is reliable;",
      "indeed, it has never crashed",
    ],
    fullEnglish: "The software is reliable; indeed, it has never crashed.",
    additionalExplanation:
      "'Indeed'는 '실제로', '정말로'라는 의미의 접속부사로, 앞서 언급한 내용을 강조하거나 확인할 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'indeed' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "온라인 판매가 증가했습니다;",
      "반면에, 매장 내 구매는 감소했습니다",
    ],
    englishChunks: [
      "Online sales grew;",
      "on the other hand, in-store purchases declined",
    ],
    fullEnglish:
      "Online sales grew; on the other hand, in-store purchases declined.",
    additionalExplanation:
      "'On the other hand'는 '반면에', '다른 한편으로는'이라는 의미의 접속구로, 대조되는 상황이나 관점을 소개할 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'on the other hand' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "그들은 예상했습니다 실패를;",
      "그와 반대로, 출시는 성공적이었습니다",
    ],
    englishChunks: [
      "They expected failure;",
      "on the contrary, the launch was a success",
    ],
    fullEnglish:
      "They expected failure; on the contrary, the launch was a success.",
    additionalExplanation:
      "'On the contrary'는 '그와 반대로', '오히려'라는 의미의 접속구로, 앞서 언급한 내용과 완전히 반대되는 상황을 나타낼 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'on the contrary' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "우리는 제공합니다 많은 서비스를;",
      "예를 들어, 클라우드 스토리지와 분석 도구",
    ],
    englishChunks: [
      "We offer many services;",
      "for example, cloud storage and analytics tools",
    ],
    fullEnglish:
      "We offer many services; for example, cloud storage and analytics tools.",
    additionalExplanation:
      "'For example'는 '예를 들어', '예컨대'라는 의미의 접속구로, 앞서 언급한 내용의 구체적인 예시를 제시할 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'for example' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "여러가지 절감 옵션이 있습니다;",
      "예를 들면, 사용하는것 번들 플랜을",
    ],
    englishChunks: [
      "There are several cost-saving options;",
      "for instance, using bundled plans",
    ],
    fullEnglish:
      "There are several cost-saving options; for instance, using bundled plans.",
    additionalExplanation:
      "'For instance'는 '예를 들면', '예컨대'라는 의미의 접속구로, 'for example'과 유사하게 구체적인 예시를 제시할 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'for instance' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },

  {
    koreanChunks: [
      "세 개의 사무실이 폐쇄되었습니다—",
      "즉, 서울, 부산, 그리고 대구",
    ],
    englishChunks: [
      "Three offices were closed—",
      "namely, Seoul, Busan, and Daegu",
    ],
    fullEnglish: "Three offices were closed—namely, Seoul, Busan, and Daegu.",
    additionalExplanation:
      "'Namely'는 '즉', '다음과 같이'라는 의미의 접속부사로, 앞서 언급한 내용의 구체적인 항목이나 예시를 열거할 때 사용합니다. 대시(—)로 연결된 두 부분 사이에서 사용되었으며, 'namely' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
  {
    koreanChunks: [
      "회의는 끝났습니다",
      " 오후 3시에;",
      "그 후, 요약본이 이메일로 발송되었습니다",
    ],
    englishChunks: [
      "The meeting ended",
      "at 3 p.m.;",
      "afterward, a summary was emailed",
    ],
    fullEnglish:
      "The meeting ended at 3 p.m.; afterward, a summary was emailed.",
    additionalExplanation:
      "'Afterward'는 '그 후에', '나중에'라는 의미의 접속부사로, 시간적 순서를 나타낼 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'afterward' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },

  {
    koreanChunks: [
      "교육은 효과적이었습니다;",
      "실제로, 생산성이 상승했습니다",
      "며칠내에",
    ],
    englishChunks: [
      "The training was effective;",
      "indeed, productivity rose",
      "within days",
    ],
    fullEnglish:
      "The training was effective; indeed, productivity rose within days.",
    additionalExplanation:
      "'Indeed'는 '실제로', '정말로'라는 의미의 접속부사로, 앞서 언급한 내용을 강조하거나 확인할 때 사용합니다. 세미콜론(;)으로 연결된 두 독립절 사이에서 사용되었으며, 'indeed' 뒤에는 일반적으로 콤마가 옵니다. 말할 때와 해석의 순서가 동일합니다.",
  },
];
